import type { CouponDetail } from '@/src/types/couponTray'
import type { Fare, VasAncillary } from '@/src/types/itinerary'
import { isEmpty } from '@/src/utils/generalUtils'
import { useMemo } from 'react'

/**
 * Hook for calculating total VAT adjustments from VAS services and coupons
 * Returns net VAT adjustment (additions from services minus coupon deductions)
 */
const useVatCalculation = (
    vasAncillaries: VasAncillary[] = [],
    selectedInsurances: VasAncillary[] = [],
    couponDetails: CouponDetail[] = [],
    selectedFare?: Fare,
    selectedFareFamily?: Fare,
    fareFamilyEnabledOnReview: boolean = false
) => {
    const additionalVat = useMemo(() => {
        let tripAddVat = 0
        let specialFareVat = 0
        let couponVatDeduction = 0

        if (!isEmpty(selectedFare)) {
            tripAddVat += selectedFare?.vatAmountOnPremium || 0
        }

        // Process selected insurances
        selectedInsurances?.forEach(insurance => {
            const { vasDetails = [] } = insurance
            vasDetails.forEach(detail => {
                tripAddVat += detail.vatAmount || 0
            })
        })

        // Process coupon VAT deductions
        couponDetails?.forEach(coupon => {
            couponVatDeduction += coupon.ct_vat || 0
        })

        return tripAddVat + specialFareVat - couponVatDeduction
    }, [vasAncillaries, selectedInsurances, couponDetails, selectedFare, selectedFareFamily, fareFamilyEnabledOnReview])

    return { additionalVat }
}

export default useVatCalculation
